import React from 'react';

import makeUrl from '../../lib/makeUrl';
import { HGCardBase, CardBodyTop, Description, CardBodyBottom } from './Common';

export default function PlaceCard(props) {
  const { placeData } = props;
  const { description, name, altitude, id, region } = placeData;
  const goToUrl = makeUrl.placeDetails(name, id, region);

  return (
    <HGCardBase className="placeCard" cardData={placeData} url={goToUrl}>
      <CardBodyTop title={name} type="place" url={goToUrl}>
        <Description description={description ? description : ''} />
      </CardBodyTop>
      <CardBodyBottom>
        <ul>
          {altitude && (
            <li>
              <span>Altitude: </span>
              {Number(altitude.meters).toLocaleString()} m
            </li>
          )}
        </ul>
      </CardBodyBottom>
    </HGCardBase>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/PlaceCard.jsx